export default __webpack_public_path__ + "static/media/bus.01a70f83.svg";